/** @jsx jsx */

import { Accordion, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import Label from './MultiSelectCheckboxes/Label';
import MultiSelectCheckboxes from './MultiSelectCheckboxes';
import { sectionStyle } from './constants';

import type { Role } from './types';

const Styles = {
  root: css`
    flex-direction: column;
  `,
};

type Props = {
  handleRoleCheckboxChange: (checkboxValue: string) => () => void;
  roles: Array<Role>;
};

function SectionRole({ roles, handleRoleCheckboxChange }: Props) {
  const options = roles.map(role => ({
    ...role,
    onKeyPress: handleRoleCheckboxChange(role.value),
  }));

  return (
    <div css={[Styles.root, sectionStyle]}>
      <Accordion
        title={
          <Label
            isRequired={true}
            title="How are you typically involved with integrations?"
          />
        }
        toggleSide="right"
      >
        <Text margin="0 0 20px" tag="p">
          We’ll personalize your experience based on the options you select.
        </Text>
        <MultiSelectCheckboxes
          isRequired={true}
          options={options}
          title={undefined}
        />
      </Accordion>
    </div>
  );
}

export default SectionRole;
